import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  height: 100%;
  padding: 0 1% 2% 2%;
  margin-bottom: 40px;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 1%;
  background-color: #eff3fa;
  margin-bottom: 20px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  padding-left: 20px;
`

export const TitleIcon = styled.img`
  width: 45px;
  height: 50px;
`

export const StepsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 3%;
  padding: 3% 0 0 0;
`

export const ConfigsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 80px;
`
export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  height: 200px;
  background-color: transparent;
`
